import React, { useEffect, useState } from "react";
import { MessageSquareReply, CheckCircle2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useConfirm } from "../context/ConfirmContext";

export const IncomingTextsCard = () => {
  const confirm = useConfirm();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/twilio/inbound-status").then(({ data }) => setS(data)).catch(() => setS({ error: true }));
  useEffect(() => { load(); }, []);
  const connect = async () => {
    if (!(await confirm({ title: "Send the church number's incoming texts here?", description: `Twilio will forward every text sent to the church number to ${s.url}. Only do this on the live site.`, confirmLabel: "Connect" }))) return;
    setBusy(true);
    try { await api.post("/twilio/connect-inbound"); toast.success("Incoming texts now come to the portal"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!s) return null;
  return (
    <div className="bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)] p-6" data-testid="incoming-texts-card">
      <h2 className="font-head text-lg font-bold flex items-center gap-2"><MessageSquareReply className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Incoming text replies</h2>
      <p className="text-sm mt-1" style={{ color: "var(--sj-text-2)" }}>When connected, replies to the church number appear in the portal: replies to a host's group text go to the host and Cell Group admins, and other replies go into that person's History with an alert for pastors.</p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {s.connected ? (
          <span data-testid="incoming-texts-status" className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "var(--sj-secondary)" }}><CheckCircle2 className="h-4 w-4" /> Connected</span>
        ) : (
          <span data-testid="incoming-texts-status" className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#B45309" }}><AlertTriangle className="h-4 w-4" /> {s.configured === false ? "Texting isn't set up" : s.error ? "Couldn't check Twilio" : "Not connected to this portal"}</span>
        )}
        {s.configured !== false && !s.connected && (
          <button data-testid="incoming-texts-connect" disabled={busy} onClick={connect} className="rounded-full px-5 py-2 text-sm font-semibold text-white disabled:opacity-60" style={{ background: "var(--sj-primary)" }}>{busy ? "Connecting…" : "Connect incoming texts"}</button>
        )}
      </div>
      {s.url && <p className="text-xs mt-3 break-all" style={{ color: "var(--sj-text-3)" }}>Portal address: {s.url}{s.current && !s.connected ? ` · Twilio currently sends to: ${s.current}` : ""}</p>}
      <p className="text-xs mt-1" style={{ color: "var(--sj-text-3)" }}>Do this on the live site, so texts go to the live portal.</p>
    </div>
  );
};
